import React from 'react';
import * as d3 from 'd3';
import ChartComponent from './ChartComponent';

const Line = ({ data, line, curve, area, animationDuration, strokeWidth = 1, color = 'black', pointConfig = {} }) => {
    function draw(chart) {
        if (curve) {
            line.curve(curve);
        }

        let graph = chart.append('path')
            .datum(data)
            .attr('class', `Line`)
            .attr('d', line)
            .attr('stroke', color)
            .attr('stroke-width', strokeWidth);

        let fill = area ? color : 'none';

        graph.attr('fill', fill);

        return graph;
    }

    function animate(graph) {
        let totalLength = graph.node().getTotalLength();
        graph.attr("stroke-dasharray", totalLength + " " + totalLength)
            .attr("stroke-dashoffset", totalLength)
            .transition()
            .duration(animationDuration * data.length)
            .attr("stroke-dashoffset", 0);
    }

    let { pointSize, cx, cy } = pointConfig;

    function plotPoints(chart) {
        if (pointSize && cx && cy) {
            data.forEach((d, i) => {
                chart.append('circle')
                    .attr('class', `Line__dot`)
                    .attr('fill', color)
                    .attr('stroke', color)
                    .attr('cx', cx(d, i))
                    .attr('cy', cy(d, i))
                    .on('mouseover', function () {
                        d3.select(this)
                            .transition()
                            .duration(100)
                            .attr('r', pointSize * 2);
                    })
                    .on('mouseout', function () {
                        d3.select(this)
                            .transition()
                            .duration(100)
                            .attr('r', pointSize);
                    })
                    .transition()
                    .delay(animationDuration * i)
                    .duration(animationDuration)
                    .attr('r', pointSize);
            });
        }
    }

    return (
        <ChartComponent
            draw={(chart) => {
                let graph = draw(chart);
                animate(graph);
                if (pointSize) {
                    plotPoints(chart);
                }
            }}
        />
    )
}

export default Line
